import React, { createContext, useContext, useRef, useCallback } from "react";

interface MessageNavigationContextType {
  registerScrollHandler: (handler: (messageId: string) => void) => void;
  navigateToMessage: (messageId: string) => void;
}

const MessageNavigationContext = createContext<MessageNavigationContextType | null>(null);

export const MessageNavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const scrollHandlerRef = useRef<((messageId: string) => void) | null>(null);

  const registerScrollHandler = useCallback((handler: (messageId: string) => void) => {
    scrollHandlerRef.current = handler;
  }, []);

  const navigateToMessage = useCallback((messageId: string) => {
    if (scrollHandlerRef.current) {
      scrollHandlerRef.current(messageId);
    } else {
      console.warn("No scroll handler registered for message navigation");
    }
  }, []);

  return (
    <MessageNavigationContext.Provider value={{ registerScrollHandler, navigateToMessage }}>
      {children}
    </MessageNavigationContext.Provider>
  );
};

export const useMessageNavigation = () => {
  const context = useContext(MessageNavigationContext);
  if (!context) {
    throw new Error("useMessageNavigation must be used within a MessageNavigationProvider");
  }
  return context;
};
